import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import Moment from "moment";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody
} from "reactstrap";
import { Breadcrumbs, Btn, H5, H6, Spinner } from "AbstractElements";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { sendNotification } from "Features/Learning/PushNotif/utils/PushNotifUtils";
import { resetState, setField } from "Features/Learning/PushNotif/addPushNotifSlice";
import ModalAddTopics from "./ModalAddTopics";
import DropzoneCommon from "Component/Learning/Common/Upload/Dropzone";
import { FCMService } from "Services/axios/FCM.Service";
import HistoryNotif from "./HistoryNotif";

const UserPostContain = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const data = useSelector((state) => state?.addPushNotif);
  const startUpload = useSelector((state) => state?.addPushNotif?.isLoading);
  const [selectedValue, setSelectedValue] = useState([]);
  const [openTopics, setOpenTopics] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const { userFcm } = location?.state || "";

  useEffect(() => {
    setSelectedValue(data?.topics)
  }, [data?.topics])

  useEffect(() => {
    if (userFcm !== undefined && userFcm !== null && userFcm !== "") {
      dispatch(setField({ field: "token", value: userFcm }));
    }
  }, [dispatch, userFcm]);

  const fetchHistoryData = async () => {
    const response = await FCMService.get();
    setHistoryData(response.data.data);
  };

  useEffect(() => {
    fetchHistoryData();
  }, []);

  const handleSuccess = async () => {
    dispatch(resetState());
    // Re-fetch history data after successful submission
    await fetchHistoryData();
    if (data.token !== "" && userFcm !== undefined && userFcm !== null && userFcm !== "") {
      history(-1);
    } else {
      history(`${process.env.PUBLIC_URL}/users/push-notif`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      (!userFcm && (!data.topics || data.topics.length === 0)) ||
      !data.title ||
      !data.body
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Data tidak boleh kosong!",
      });
      return;
    }

    // Jika user mengisi scheduled_at, tampilkan peringatan bahwa tidak bisa dibatalkan
    if (data?.scheduled_at) {
      const result = await Swal.fire({
        title: "Notifikasi Terjadwalkan",
        text: "Notifikasi yang dijadwalkan tidak bisa dibatalkan setelah dikirim. Lanjutkan?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, kirim",
        cancelButtonText: "Batal",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      if (!result.isConfirmed) return;
    }

    dispatch(sendNotification({ ...data, successCallback: handleSuccess }));
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    if (name === "body" && value.length > 100) return;
    if (name === "title" && value.length > 50) return;
    dispatch(setField({ field: name, value: value }));
  };

  const handlePasteTitle = (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    if (paste.length > 50) {
      e.preventDefault();
      dispatch(setField({ field: "title", value: paste.slice(0, 50) }));
    }
  };

  const handlePasteBody = (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    if (paste.length > 100) {
      e.preventDefault();
      dispatch(setField({ field: "body", value: paste.slice(0, 100) }));
    }
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption);
    dispatch(setField({ field: "topics", value: selectedOption }));
  };

  const handleOpenTopics = () => {
    setOpenTopics(!openTopics);
  };

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === "removed") {
      dispatch(setField({ field: "image", value: "" }));
    } else if (status === "done") {
      dispatch(setField({ field: "image", value: file }));
    }
  };

  // schedule handler: no local state, update redux directly
  const handleScheduleChange = (date) => {
    if (!date) {
      dispatch(setField({ field: "scheduled_at", value: "" }));
      return;
    }
    dispatch(
      setField({
        field: "scheduled_at",
        value: Moment(date).format("YYYY-MM-DD HH:mm:ss"),
      })
    );
  };

  return (
    <>
      <Breadcrumbs parent="User Brofesional" title={"Push Notification"} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader className='pb-0'><H5>Notifikasi User</H5></CardHeader>
              <CardBody className="add-post">
                {startUpload ? (
                  <Col lg="12">
                    <div className="loader-box">
                      <Spinner attrSpinner={{ className: "loader-30" }} />
                    </div>
                    <H6 attrH6={{ className: "sub-title mb-0 text-center" }}>
                      {"Sedang proses unggah..."}
                    </H6>
                  </Col>
                ) : (
                  <div>
                    <Form className="row needs-validation">
                      <Col sm="12">
                        {
                          userFcm === undefined &&
                          <>
                            <Label className="col-form-label" style={{ fontWeight: 'bold' }}>Topik :</Label>
                            {selectedValue.length > 0 && (
                              <ul className="list-group mb-3">
                                {selectedValue.map(item => (
                                  <li key={`selected-topic-${item.id}`} className="list-group-item">
                                    {item.title}
                                  </li>
                                ))}
                              </ul>
                            )}
                            <Button color={selectedValue.length > 0 ? 'success' : 'primary'} style={{ display: "block" }} onClick={handleOpenTopics}>{selectedValue.length > 0 ? "Edit" : 'Pilih'} Topik ({selectedValue.length})</Button>
                            <div>
                              <small className="text-muted">Pilih topik untuk notifikasi. <b>MAKSIMAL</b> 5 topik.</small>
                            </div>
                          </>
                        }
                        <ModalAddTopics openTopics={openTopics} handleOpenTopics={handleOpenTopics} selectedValue={selectedValue} handleSelectChange={handleSelectChange} />
                        {
                          userFcm !== undefined && (
                            <FormGroup className="mb-3">
                              <Label for="url" style={{ fontWeight: "bold" }}>
                                Token FCM User :
                              </Label>
                              <Input
                                className="form-control"
                                id="token"
                                type="text"
                                name="token"
                                value={userFcm}
                                onChange={handleChanges}
                                disabled
                                readOnly
                              />
                            </FormGroup>
                          )
                        }
                        <FormGroup className="my-3">
                          <Label for="title" style={{ fontWeight: "bold" }}>
                            Judul :
                          </Label>
                          <Input
                            className="form-control"
                            id="title"
                            type="text"
                            name="title"
                            placeholder="Masukkan Judul..."
                            value={data?.title}
                            onChange={handleChanges}
                            maxLength={50}
                            onPaste={handlePasteTitle}
                            style={{
                              borderColor: data?.title?.length === 50 ? "red" : data?.title?.length > 50 ? "red" : undefined,
                              background: data?.title?.length === 50 ? "#fffbe6" : data?.title?.length > 50 ? "#ffeaea" : undefined
                            }}
                          />
                          <div style={{ fontSize: "0.9em", color: data?.title?.length === 50 ? "red" : data?.title?.length > 50 ? "red" : "#888" }}>
                            {data?.title?.length || 0}/50 karakter
                            {data?.title?.length === 50 && " (Maksimal tercapai)"}
                            {data?.title?.length > 50 && " (Maksimal 50 karakter)"}
                            {data?.title?.length < 50 && ` (Sisa ${50 - (data?.title?.length || 0)} karakter)`}
                          </div>
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Label for="body" style={{ fontWeight: "bold" }}>
                            Deskripsi :
                          </Label>
                          <Input
                            className="form-control"
                            id="body"
                            type="text"
                            name="body"
                            placeholder="Masukkan Deskripsi..."
                            value={data?.body}
                            onChange={handleChanges}
                            maxLength={100}
                            onPaste={handlePasteBody}
                            style={{
                              borderColor: data?.body?.length === 100 ? "red" : data?.body?.length > 100 ? "red" : undefined,
                              background: data?.body?.length === 100 ? "#fffbe6" : data?.body?.length > 100 ? "#ffeaea" : undefined
                            }}
                          />
                          <div style={{ fontSize: "0.9em", color: data?.body?.length === 100 ? "red" : data?.body?.length > 100 ? "red" : "#888" }}>
                            {data?.body?.length || 0}/100 karakter
                            {data?.body?.length === 100 && " (Maksimal tercapai)"}
                            {data?.body?.length > 100 && " (Maksimal 100 karakter)"}
                            {data?.body?.length < 100 && ` (Sisa ${100 - (data?.body?.length || 0)} karakter)`}
                          </div>
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Label for="url" style={{ fontWeight: "bold" }}>
                            Diarahkan ke url (opsional) :
                          </Label>
                          <Input
                            className="form-control"
                            id="url"
                            type="url"
                            name="url"
                            placeholder="Masukkan Url..."
                            value={data?.url}
                            onChange={handleChanges}
                          />
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Label for="analytics_label" style={{ fontWeight: "bold" }}>
                            Label Analytics :
                          </Label>
                          <Input
                            className="form-control"
                            id="analytics_label"
                            type="select"
                            name="analytics_label"
                            value={data?.analytics_label || ""}
                            onChange={handleChanges}
                          >
                            <option value="">-- Pilih Label --</option>
                            <option value="cpns_offline">CPNS Offline</option>
                            <option value="cpns_online">CPNS Online</option>
                            <option value="sekdin_offline">Sekdin Offline</option>
                            <option value="sekdin_online">Sekdin Online</option>
                            <option value="bumn">BUMN</option>
                            <option value="pcpm_bi">PCPM BI</option>
                            <option value="pppk">PPPK</option>
                            <option value="snbt">SNBT</option>
                            <option value="interview">Interview</option>
                            <option value="psikotes">Psikotes</option>
                            <option value="toefl">TOEFL</option>
                            <option value="voice_over">Voice Over</option>
                            <option value="public_speaking">Public Speaking</option>
                            <option value="pascasarjana">Pascasarjana</option>
                            <option value="job_preparation">Job Preparation</option>
                            <option value="announcement">Announcement</option>
                            <option value="odp">ODP</option>
                            <option value="mt">MT</option>
                            <option value="web_programming">Web Programming</option>
                            <option value="konseling_cv">Konseling CV</option>
                          </Input>
                          <small className="text-muted">
                            Pilih label untuk tracking analytics notifikasi ini.
                          </small>
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <Label for="scheduled_at" style={{ fontWeight: "bold" }}>
                            Jadwalkan Kirim (opsional) :
                          </Label>
                          <Col>
                            <DatePicker
                              className="form-control digits"
                              showPopperArrow={false}
                              selected={
                                data?.scheduled_at
                                  ? Moment(data.scheduled_at, "YYYY-MM-DD HH:mm:ss").toDate()
                                  : null
                              }
                              showTimeSelect
                              timeFormat="HH:mm:ss"
                              dateFormat="dd-MM-yyyy HH:mm:ss"
                              closeOnScroll={true}
                              onChange={handleScheduleChange}
                              isClearable={true}
                              placeholderText="Pilih tanggal!"
                            />
                          </Col>
                          <p style={{ fontSize: "0.9em", color: "#888" }}>
                            Kosongkan jika ingin mengirim langsung.
                          </p>
                        </FormGroup>
                        <FormGroup className="mb-3">
                          <DropzoneCommon
                            label={"Gambar (opsional)"}
                            inputContent={
                              data.image ? "Ganti gambar..." : "Silahkan upload gambar..."
                            }
                            handleChangeStatus={handleChangeStatus}
                            accept="image/*"
                          />
                          <p style={{ fontSize: "0.9em", color: "#888" }}>
                            Rekomendasi gambar berukuran <b>16:9</b> untuk hasil terbaik.
                          </p>
                        </FormGroup>
                      </Col>
                    </Form>
                    <div className="btn-showcase text-end">
                      <Btn attrBtn={{ color: 'primary', type: 'submit', onClick: handleSubmit }}>Post</Btn>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {(historyData && historyData.length > 0) && (
        <HistoryNotif historyData={historyData} />
      )}
    </>
  );
};

export default UserPostContain;
